import { render } from "./ConversationEdit.vue?vue&type=template&id=4ff0e6c5"
import script from "./ConversationEdit.vue?vue&type=script&lang=js"
export * from "./ConversationEdit.vue?vue&type=script&lang=js"

import "./ConversationEdit.vue?vue&type=style&index=0&id=4ff0e6c5&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__